export const environment = {
  production: false,
  maintenance: false,
  backend: {
    baseUrl: "https://be-uat.siram.elvoon.it/approva-ws/api/v1",
  },
  oauth2_redirect_url: "https://be-uat.siram.elvoon.it/oauth2/redirect",
  googleOauth: {
    clientId: "1071512568828-54qlqqdihsll11vgjodbdah47t4asm4m.apps.googleusercontent.com"
  },
  google: { 
    auth_url:
    "https://be-uat.siram.elvoon.it/approva-ws/api/v1/oauth2/authorize/google?redirect_uri=https://approva-uat.siram.elvoon.it/authentication/oauth2/redirect", 
    clientId:
      "1071512568828-qn9kf5fbg68uq3eckatc86ul4m1t2k3q.apps.googleusercontent.com",
      appId:'1071512568828', // #gitleaks:allow // NOT CHANGED
      apikeydrive:'AIzaSyBFI8z-odTCBZt0K8k3fwPb8ZAD42GmQiU', // #gitleaks:allow // NOT CHANGED
      mapkey:'AIzaSyA-kzJ63hhEvTkMphLj9wS194ilZ1dhDTQ' // #gitleaks:allow // OLD -> AIzaSyD5x5lo2OTmK_mCG2Mwom-9viEkSSiR7PQ
  },
  deleghe: "marco.taranto@veolia.com"
};